module.exports = __webpack_public_path__ + "static/media/internacional-de-seguros-pin.365b9497.svg";